import FootballCountryModel from "../Country/FootballCountryModel";
import PlayerAssetsModel from "./PlayerAssetsModel";


export default class PlayerSquadModel {
    public id: string = "";
    public startDate: string = "";
    public endDate: string = "";
    public shirtNumber: number;
    public loan: boolean = false;
    public position: string = "";
    public country: FootballCountryModel = null;
    public name: string = "";
    public assets: PlayerAssetsModel = null;
    public birthDate: string = "";

}